import { useEffect } from 'react';

/**
 * Custom hook to set the document title
 * @param title The page-specific title to set
 * @param includeAppName Whether to append the app name to the title (default: true)
 */
export const useDocumentTitle = (title: string, includeAppName = true) => {
  useEffect(() => {
    const appName = 'Sequence Planner';
    const newTitle = includeAppName ? `${title} | ${appName}` : title;

    // Update the document title
    document.title = newTitle;

    // Restore the previous title when the component unmounts
    return () => {
      document.title = appName;
    };
  }, [title, includeAppName]);
};

export default useDocumentTitle; 